// extracted by mini-css-extract-plugin
export default {"groupForm":"PointsModal_groupForm__77tiy","inputForNumber":"PointsModal_inputForNumber__W-Ta8"};